import styled from 'styled-components';
import { ResponsiveWidth } from '../../../../components/Css';
import { Typography } from 'antd';

const { Text } = Typography;

export const WelcomeContentArea = styled.div`
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  padding-top: 156px;
  background-color: #f9f9f9;

  @media (max-width: 992px) {
    padding-top: 88px;
  }
`;

export const WelcomeContainer = styled.div<{ $isMobile?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  text-align: center;
  height: 100vh;
  overflow: ${(props) => (props.$isMobile ? 'auto' : 'hidden')};
  min-height: 0;
  background-color: var(--color-background-welcome);
  background-image: var(--color-image-welcome);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const ImageWrapper = styled.div`
  margin-bottom: var(--spacing-regular);
  height: auto;
  margin-top: var(--spacing-regular);
  flex-shrink: 0;
`;

export const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 0;
  width: 100%;
`;

export const ImageContainer = styled.div<{
  $bannerUrl?: string;
  $isMobile?: boolean;
  $hasHelpBanner?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  max-height: ${(props) => (props.$hasHelpBanner ? '400px' : '558px')};
  aspect-ratio: 1200 / 558;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-image: ${(props) =>
    props.$bannerUrl ? `url(${props.$bannerUrl})` : 'none'};

  @media (max-width: 425px) {
    max-height: ${(props) => (props.$hasHelpBanner ? '400px' : 'none')};
    aspect-ratio: auto;
    min-height: 200px;
  }
`;

export const WelcomeFooter = styled.div<{ $isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
  height: auto;
  width: 300px;
  flex-shrink: 0;
  padding: var(--spacing-regular) 0;
  margin-bottom: var(--spacing-regular);

  @media (min-width: ${ResponsiveWidth}px) {
    width: 500px;
    margin-top: 20px;
  }
`;

export const LinkText = styled(Text)`
  font-weight: bold;
  cursor: pointer;
  color: var(--colorSecondary);
  font-size: var(--font-paragraph);
`;

export const LinkRegister = styled.div`
  color: var(--color-button-text);
  font-size: var(--font-paragraph);
`;

export const LinkCopyRigth = styled(LinkText)`
  font-size: var(--font-paragraph);
`;

export const HelpBanner = styled.div<{ $isMobile?: boolean }>`
  width: 100%;
  height: auto;
  min-height: 100px;
  background-color: var(--color-background-welcome-footer);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-welcome-footer);
  font-size: var(--font-paragraph);
  text-align: center;
  padding: var(--spacing-regular);
  box-sizing: border-box;
  flex-shrink: 0;
  a {
    padding-left: var(--spacing-small);
    padding-right: var(--spacing-small);
    text-decoration: underline;
    color: var(--color-highlight);
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const WelcomeHeader = styled.header<{ $isMobile?: boolean }>`
  width: 100%;
  min-height: 56px;
  background-color: var(
    --color-background-header,
    var(--color-background-welcome-footer)
  );
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-regular) var(--spacing-large);
  box-sizing: border-box;
  flex-shrink: 0;
  color: var(--color-header-text, var(--color-text-welcome-footer));
`;

export const WelcomeHeaderContainer = styled.div`
  width: 100%;
  max-width: 1260px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 var(--spacing-big);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  @media screen and (max-width: 768px) {
    padding: 0 var(--spacing-small);
  }
`;

export const WelcomeHeaderLogo = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  img {
    max-height: 32px;
    width: auto;
    object-fit: contain;
  }
  @media (min-width: ${ResponsiveWidth}px) {
    img {
      max-height: 40px;
    }
  }
`;

export const WelcomeHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
  flex-shrink: 0;
`;
